import { ControlMenuActionTypes } from '@thoughtspot/chart-common';
import { create } from '@thoughtspot/logger';
import { AxisMenuActions, TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import Joi from 'joi';
import _ from 'lodash';
const logger = create('axis-menu/util');
const customActionSchema = Joi.object({
    id: Joi.string().required(),
    label: Joi.string().required(),
    icon: Joi.string().allow(null),
    onClick: Joi.func().required(),
}).unknown(false);
const openAxisMenuEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    columnIds: Joi.array()
        .items(Joi.string())
        .min(1)
        .required(),
    selectedActions: Joi.alternatives().try(Joi.array()
        .items(Joi.any().valid(...Object.values(AxisMenuActions)), null)
        .required(), Joi.valid(null)),
    customActions: Joi.alternatives().try(Joi.array()
        .items(customActionSchema)
        .empty(), Joi.allow(null)),
}).unknown(false);
export const validateColumnIdList = (columnIdList, columns) => {
    columnIdList.forEach(colId => {
        const idx = columns.findIndex(col => col.id === colId);
        if (idx === -1) {
            logger.error('columnId List is invalid. columnId not found in the model.', colId);
            throw new Error(`columnId List is invalid. column with id:${colId} not found in the model.`);
        }
    });
};
export const validateOpenAxisMenuEventPayloadObject = (object, columns) => {
    try {
        Joi.assert(object, openAxisMenuEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
    validateColumnIdList(object.columnIds, columns);
};
const SDKActionsToAppActionsMap = {
    [AxisMenuActions.AGGREGATE]: ControlMenuActionTypes.AGGREGATE,
    [AxisMenuActions.TIME_BUCKET]: ControlMenuActionTypes.TIME_BUCKET,
    [AxisMenuActions.FILTER]: ControlMenuActionTypes.FILTER,
    [AxisMenuActions.SORT]: ControlMenuActionTypes.SORT,
    [AxisMenuActions.SEPARATOR]: ControlMenuActionTypes.SEPARATOR,
    [AxisMenuActions.EDIT]: ControlMenuActionTypes.EDIT,
    [AxisMenuActions.REMOVE]: ControlMenuActionTypes.REMOVE,
    [AxisMenuActions.CONDITIONAL_FORMAT]: ControlMenuActionTypes.CONDITIONAL_FORMAT,
};
export const mapSDKAxisActionsToHostActions = (selectedSDKActions) => {
    const selectedActions = [];
    selectedSDKActions?.forEach(action => {
        const hostAction = SDKActionsToAppActionsMap[action];
        if (!_.isNil(hostAction)) {
            selectedActions.push(hostAction);
        }
    });
    return selectedActions;
};
export const updateCustomActionOnClickCallback = (customActions, emitEvent, columnIds, event) => {
    return customActions?.map(action => {
        return {
            ...action,
            cascadingItems: action.cascadingItems?.map(cascadingItem => {
                return {
                    ...cascadingItem,
                    items: cascadingItem.items?.map(item => {
                        return {
                            ...item,
                            onClick: () => emitEvent(TSToChartEvent.AxisMenuActionClick, {
                                id: item.id,
                                columnIds,
                                event,
                            }),
                        };
                    }),
                };
            }),
            onClick: () => emitEvent(TSToChartEvent.AxisMenuActionClick, {
                id: action.id,
                columnIds,
                event,
            }),
        };
    });
};
export const testHooks = {
    customActionSchema,
};
//# sourceMappingURL=util.js.map